var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1111 20.2222C8.18375 20.2222 5 17.0385 5 13.1111C5 9.18375 8.18375 6 12.1111 6H14",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8284 3.17157L14.6569 6L11.8284 8.82843",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7361 10.0281C18.8291 10.2269 18.9113 10.4349 18.9935 10.6429C19.0264 10.726 19.0584 10.8192 19.0913 10.9024C19.1159 10.9647 19.1414 11.0172 19.1561 11.0787L19.1717 11.1302L20.3553 10.6817C19.9543 9.41473 19.2934 8.29 18.3892 7.34132C18.1481 7.08839 17.749 7.09548 17.4979 7.33848C17.4753 7.3604 17.4526 7.38237 17.4299 7.40439C17.2091 7.61854 17.2014 7.97177 17.4215 8.18654C17.9657 8.73605 18.4124 9.36737 18.7252 10.0372L18.7361 10.0281Z",
    fill: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4883 12.49L20.2293 12.4673C19.8979 12.4684 19.5674 12.4596 19.227 12.4499L19.2226 12.4997L19.2181 12.7804C19.2059 12.9199 19.2137 13.0611 19.2023 13.1906C19.1822 13.6506 19.1204 14.127 18.9881 14.6073C18.8835 14.9997 18.7265 15.4176 18.5036 15.9C18.4659 15.987 18.4281 16.0741 18.3904 16.1611L18.3652 16.2192L19.515 16.7313C20.2031 15.4062 20.5287 13.9791 20.4883 12.49Z",
    fill: "#20242E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6928 19.3007L14.4541 19.3903C14.4541 19.3903 14.4441 19.3894 14.4342 19.3885C14.5903 19.7836 14.7365 20.1779 14.8836 20.5621C16.308 20.1146 17.5503 19.3399 18.5787 18.2553L17.7155 17.3366L17.6496 17.4011C17.5404 17.502 17.442 17.5938 17.3328 17.6947C16.8401 18.1635 16.2928 18.5674 15.6836 18.8754C15.3682 19.0386 15.0255 19.1692 14.7036 19.2916L14.6928 19.3007Z",
    fill: "#20242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.221e5db6b22dae542b33d00d43b67d1c.svg";
export { ForwardRef as ReactComponent };